import { render } from "./CartDrawerStartersetItem.vue?vue&type=template&id=5bf91a85"
import script from "./CartDrawerStartersetItem.vue?vue&type=script&lang=js"
export * from "./CartDrawerStartersetItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__